import { ethers } from "ethers";
// 假设您的 ABI 在本地，路径需要根据您的项目调整
import AroundUIHelperABI from "../abis/AroundUIHelper.json";

/**
 * 预测市场合约 AroundUIHelper 的 ethers.js 封装
 */
export class AroundUIHelperContract {
  /**
   * @type {ethers.Contract}
   */
  contract;

  /**
   * * @param {string} contractAddress 合约地址
   * @param {ethers.Provider | ethers.Signer} providerOrSigner ethers 提拱者或签名者
   */
  constructor(contractAddress, providerOrSigner) {
    this.contract = new ethers.Contract(
      contractAddress,
      AroundUIHelperABI.abi, // 替换为实际的 ABI JSON
      providerOrSigner
    );
  }

  // ------------------------------------
  // ⬇️ 读接口 (View Functions)
  // ------------------------------------

  /**
   * 获取yes价格
   * @param marketId 市场id, bignumber
   * @returns {Promise<string>} yes price（需要/1e18）
   */
  async getYesPrice(marketId) {
    try {
      return await this.contract.getYesPrice(marketId);
    } catch (error) {
      console.error("Error fetching yes price:", error);
      throw error;
    }
  }

  /**
   * 获取no价格
   * @param marketId 市场id, bignumber
   * @returns {Promise<string>} no price（需要/1e18）
   */
  async getNoPrice(marketId) {
    try {
      return await this.contract.getNoPrice(marketId);
    } catch (error) {
      console.error("Error fetching no price:", error);
      throw error;
    }
  }

  async getBuySlippage(marketId, bet, amountIn) {
    try {
      return await this.contract.getBuySlippage(marketId, bet, amountIn);
    } catch (error) {
      return 0n;
    }
  }

  async getSellSlippage(marketId, bet, sellAmount) {
    try {
      return await this.contract.getSellSlippage(marketId, bet, sellAmount);
    } catch (error) {
      return 0n;
    }
  }

  async getBuyOutput(bet, buyCollateralAmount, marketId) {
    try {
      return await this.contract.getBuyOutput(bet, buyCollateralAmount, marketId);
    } catch (error) {
      console.error("Error fetching buy output:", error);
      throw error;
    }
  }

  async getSellOutput(bet, sellShareAmount, marketId) {
    try {
      return await this.contract.getSellOutput(bet, sellShareAmount, marketId);
    } catch (error) {
      console.error("Error fetching sell output:", error);
      throw error;
    }
  }

  async getGuardedAmount(expectVirtualAmount, decimals) {
    try {
      return await this.contract.getGuardedAmount(
        expectVirtualAmount,
        Number(decimals)
      );
    } catch (error) {
      console.warn("Error fetching guarded amount, falling back to 0:", error?.message || error);
      return 0n;
    }
  }

  async getLiquidityValue(marketId, user) {
    try {
      return await this.contract.getLiquidityValue(marketId, user);
    } catch (error) {
      console.error("Error fetching user liquidity value:", error);
      throw error;
    }
  }

  async getLiquidityRemoval(marketId, lpAmount) {
    try {
      return await this.contract.getLiquidityRemoval(marketId, lpAmount);
    } catch (error) {
      console.error("Error fetching liquidity remove:", error);
      throw error;
    }
  }

  async getLiquidityShares(marketId, value) {
    try {
      return await this.contract.getLiquidityShares(marketId, value);
    } catch (error) {
      console.error("Error fetching liquidity shares:", error);
      throw error;
    }
  }

  async getLpSharesToMint(marketId, value) {
    try {
      return await this.contract.getLpSharesToMint(marketId, value);
    } catch (error) {
      console.error("Error fetching shares in add liquidity:", error);
      throw error;
    }
  }

  async estimateWinAmount(bet, amountIn, marketId) {
    try {
      return await this.contract.estimateWinAmount(bet, amountIn, marketId);
    } catch (error) {
      console.warn("Error estimate winnings:", error?.message || error);
      return 0n;
    }
  }

  async indexMarketData(marketId) {
    try {
      return await this.contract.indexMarketData(marketId);
    } catch (error) {
      console.error("Error index market data:", error);
      throw error;
    }
  }

  async batchIndexMarketData(index, size) {
    try {
      return await this.contract.batchIndexMarketData(index, size);
    } catch (error) {
      console.error("Error batch index market data:", error);
      throw error;
    }
  }

  async batchIndexMarketTypeData(marketType, index, size) {
    try {
      return await this.contract.batchIndexMarketTypeData(
        marketType,
        index,
        size
      );
    } catch (error) {
      console.error("Error batch index type market data:", error);
      throw error;
    }
  }

  async batchIndexUserParticipateIdsInfo(user, index, size) {
    try {
      return await this.contract.batchIndexUserParticipateIdsInfo(user, index, size);
    } catch (error) {
      console.error("Error batch index user markets:", error);
      throw error;
    }
  }

  async getDecimals(token) {
    try {
      return await this.contract.getDecimals(token);
    } catch (error) {
      try {
        const erc20 = new ethers.Contract(token, ["function decimals() view returns (uint8)"], this.contract.runner);
        const d = await erc20.decimals();
        return d;
      } catch (e2) {
        return 18;
      }
    }
  }

  async getTokenBalance(token, addr) {
    try {
      return await this.contract.getTokenBalance(token, addr);
    } catch (error) {
      try {
        const erc20 = new ethers.Contract(token, ["function balanceOf(address) view returns (uint256)"], this.contract.runner);
        return await erc20.balanceOf(addr);
      } catch (e2) {
        return 0n;
      }
    }
  }
} 
